import type { Collector } from "./types";
import { isBrowser } from "./types";

export interface NetworkInfo {
  connection?: {
    effectiveType?: string;
    downlink?: number;
    rtt?: number;
    saveData?: boolean;
  };
  ipv6Support?: boolean;
  ipv4Support?: boolean;
  dualStack?: boolean;
  connectionTest?: {
    ipv6Latency?: number;
    ipv4Latency?: number;
    ipv6Success?: boolean;
    ipv4Success?: boolean;
  };
  timingAnalysis?: {
    rttJitter?: number;
    vpnIndicatorScore?: number;
    incognitoIndicatorScore?: number;
  };
}

export const networkCollector: Collector<NetworkInfo> = {
  name: "network",
  version: 1,
  timeoutMs: 1000,
  async collect() {
    return await getNetworkInfo();
  },
};

async function getNetworkInfo(): Promise<NetworkInfo> {
  if (!isBrowser) return {};
  const out: NetworkInfo = {};

  try {
    const conn =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;
    if (conn) {
      out.connection = {
        effectiveType: conn.effectiveType,
        downlink: typeof conn.downlink === "number" ? conn.downlink : undefined,
        rtt: typeof conn.rtt === "number" ? conn.rtt : undefined,
        saveData: typeof conn.saveData === "boolean" ? conn.saveData : undefined,
      };
    }
  } catch {
    /* ignore */
  }

  // IPv6/IPv4 connectivity tests removed to prevent console errors and improve performance.
  // Core VPN/incognito detection uses MaxMind GeoIP, detectIncognito.js, etc.

  return out;
}
